import {
    AggregationMode,
    DateOrder,
    Limit,
    NameBuilderConfiguration,
    PeriodReference,
    RowSpacing,
    TimeInterval
} from '../../models';
import { ITableConfiguration } from '../table/ITableConfiguration';
import { ISeriesSortingConfiguration } from './ISeriesSortingConfiguration';
import { PivotTableRowSeriesDefinition } from './PivotTableRowSeriesDefinition';
import { PivotTableSeriesDefinition } from './PivotTableSeriesDefinition';

export class PivotTableConfiguration implements ITableConfiguration, ISeriesSortingConfiguration {
    aggregationColumnMode: AggregationMode;
    alignedOn: PeriodReference;
    dashboardGuid: string;
    isEndDateIncluded: boolean;
    limit: Limit;
    maxItems: number;
    maxPeriod: TimeInterval;
    minPeriod: TimeInterval;
    nameConfiguration: NameBuilderConfiguration;
    rowSpacing: RowSpacing;
    series: PivotTableSeriesDefinition[];
    sortBy: string;
    sortOrder: DateOrder;
    rowSeries: PivotTableRowSeriesDefinition;

    constructor() {
        this.rowSpacing = RowSpacing.Normal;
        this.alignedOn = PeriodReference.End;
        this.isEndDateIncluded = false;
        this.aggregationColumnMode = AggregationMode.None;
        this.nameConfiguration = new NameBuilderConfiguration(true, false, false, true, false);
        this.series = [];
        this.rowSeries = {
            guid: '',
            value: '',
            isBoundToGroup: false,
            originalGuid: '',
            decimals: 2,
            bin: 10
        };
        this.sortBy = '';
        this.sortOrder = DateOrder.Increasing;
        this.limit = Limit.None;
        this.maxItems = 10;
    }
}